// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G9s_D","icon":"styles_icon__15An3"};